import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import MnSpinner from "@mnjsplatform/components/lib/common/MnSpinner";
import { Form, Field } from "react-final-form";
import { FORM_ERROR } from 'final-form'
import HomeApi from "../../api/homeApi";
import * as ea from "@mnjsplatform/data/lib/actions/errorActions";
import {withRouter} from "react-router";
import toastr from 'toastr';
import i18next from 'i18next';

class ChangePassword extends Component {
    constructor(props, context) {
        super(props, context);

        toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-top-center",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "4000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        }
    }

    sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

    componentDidMount() {
    }

    onSubmit = async (values)  => {
        try {
            //await this.sleep(5000);
            const d = await HomeApi.changePassword(values.oldPassword, values.newPassword1, values.newPassword2);
            if (!d.IsSuccess)
                return { [FORM_ERROR]: d.ErrorMessage };

            toastr.success(i18next.t("PasswordHasBeenChanged"));
            this.navigateBack();
        }
        catch(e)
        {
            this.props.dispatch(ea.errorRaised(e))
        }
    };

    navigateBack = () => {
        if (this.props.history.action === 'PUSH') {
            this.props.history.goBack();
        } else {
            this.props.history.replace('/');
        }
    };

    renderForm() {
        return (<Form
            onSubmit={this.onSubmit}
            validate={values => {
                const errors = {};
                if (!values.oldPassword) {
                    errors.oldPassword = i18next.t("RequiredField");
                }
                if (!values.newPassword1) {
                    errors.newPassword1 = i18next.t("RequiredField");
                }
                if (!values.newPassword2) {
                    errors.newPassword2 = i18next.t("RequiredField");
                } else if (values.newPassword1 !== values.newPassword2) {
                    errors.newPassword2 = i18next.t("PasswordsShouldBeEqual");
                }
                return errors;
            }}
            render={({submitError, handleSubmit, reset, submitting, pristine, values }) => (
                <form onSubmit={handleSubmit}>
                    <Field name="oldPassword">
                        {({ input, meta }) => (
                            <div className="form-group pt-1">
                                <div>{i18next.t("CurrentPassword")}</div>
                                <input {...input} type="password" className="form-control">
                                </input>
                                {meta.error && meta.touched && <span className="alert-danger">{meta.error}</span>}
                            </div>
                        )}
                    </Field>
                    <Field name="newPassword1">
                        {({ input, meta }) => (
                            <div className="form-group pt-1">
                                    <div>{i18next.t("NewPassword")}</div>
                                <input {...input} type="password" className="form-control">
                                </input>
                                {meta.error && meta.touched && <span className="alert-danger">{meta.error}</span>}
                            </div>
                        )}
                    </Field>
                    <Field name="newPassword2">
                        {({ input, meta }) => (
                            <div className="form-group pt-1">
                                <div>{i18next.t("RepeatPassword")}</div>
                                <input {...input} type="password" className="form-control" />
                                {meta.error && meta.touched && <span className="alert-danger">{meta.error}</span>}
                            </div>
                        )}
                    </Field>
                    {submitError && <span className="alert-danger">{submitError}</span>}
                    <MnSpinner active = {submitting} />
                    <div className="pt-4">
                        <button type="submit" className="btn btn-regular -goahead" disabled={submitting}>{i18next.t("Save")}</button>
                        <button type="button" className="btn btn-regular" onClick={this.navigateBack} disabled={submitting}>{i18next.t("CancelNoun")}</button>
                    </div>
                </form>
            )}
        />);
    }

    render() {
        return (<div>
            <div className="row" style={{marginTop: "10px", marginBottom: "10px"}}>
                <div className="col-md-9">
                    <h1 className="page-title">
                        {i18next.t("PasswordChanging")}
                    </h1>
                </div>
            </div>
            <div className="col-md-2 col-sm-6">
                {this.renderForm()}
            </div>
        </div>)
    }

}

ChangePassword.propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object,
    history: PropTypes.object
};


ChangePassword.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        state: state
    }
}

export default withRouter(connect(mapStateToProps)(ChangePassword))